import React, { useEffect } from 'react'
import Pagetitle from './component/Pagetitle'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from "react-hook-form";
import { useApiStore } from './hooks/ApiStoreContext';
import { useAuth } from './hooks/AuthProvider';
import Swal from 'sweetalert2';

function Login() {
    const navigate = useNavigate();
    const apiStore = useApiStore();
    const auth = useAuth();

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm({
        mode: "onBlur",
        defaultValues: {
            username: "",
            password: "",
        },
    });

    const {
        register: registerRecover,
        handleSubmit: handleSubmitRecover,
        formState: { errors: errorsRecover },
        reset: resetRecover,
        setValue: setValueRecover
    } = useForm({
        mode: "onBlur",
        defaultValues: {
            username: "",
        },
    });

    useEffect(() => {
        if (auth.token !== "") {
            navigate('/my-account');
        }
    }, [auth.token, navigate]);

    const handleLogin = async (data) => {
        var res = await auth.loginAction({ username: data.username, password: data.password });
        if (res.status === 200) {
            resetLogin();
            navigate('/my-account');
        } else {
            await Swal.fire({
                title: "Login failed!",
                text: "Invalid login credentials.",
                icon: "warning",
                confirmButtonText: "OK"
            });
        }
    };

    const handleResetPassword = async (data) => {
        try {
            await apiStore.post('/auth/reset-password', { username: data.username });
            await Swal.fire({
                title: "Success",
                text: "A password reset link has been sent to your registered email.",
                icon: "success",
                confirmButtonText: "OK"
            });
            resetRecover();
        } catch (error) {
            console.error("Error resetting password:", error);
            let errorMessage = "Failed to send reset link.";
            if (error.response?.data?.detail) {
                errorMessage = error.response.data.detail;
            }
            await Swal.fire({
                title: "Error",
                text: errorMessage,
                icon: "error",
                confirmButtonText: "OK"
            });
        }
    };

    const resetLogin = () => {
        reset({
            username: "",
            password: "",
        });
    };

    return (
        <>
            <Pagetitle title="Log in"></Pagetitle>
            <section className="flat-spacing-10">
                <div className="container">
                    <div className="tf-grid-layout lg-col-2 tf-login-wrap">
                        <div className="tf-login-form">
                            <div id="recover">
                                <h5 className="mb_24">Reset your password</h5>
                                <p className="mb_30">We will send you an email to reset your password</p>
                                <div>
                                    <form className="" id="EmailRecoveryform" onSubmit={handleSubmitRecover(handleResetPassword)}>
                                        <div className="tf-field style-1 mb_15">
                                            <input
                                                className="tf-field-input tf-input"
                                                placeholder=""
                                                type="text"
                                                id="txtLoginIdRecover"
                                                {...registerRecover("username", {
                                                    required: "Login ID is required.",
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9_-]{6,}$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$|^\d{10}$/,
                                                        message: "Please enter a valid Login ID (min 6 characters), Email, or 10-digit Contact number."
                                                    }
                                                })}
                                            />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="txtLoginIdRecover">Login ID *</label>
                                            <span className="text-xs text-danger">{errorsRecover.username?.message}</span>
                                        </div>
                                        <div className="mb_20">
                                            <a href="#login" className="tf-btn btn-line">Cancel</a>
                                        </div>
                                        <div className="">
                                            <button type="submit" className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center">Reset password</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div id="login">
                                <h5 className="mb_36">Log in</h5>
                                <div>
                                    <form className="" id="login-form" acceptCharset="utf-8" onSubmit={handleSubmit(handleLogin)}>
                                        <div className="tf-field style-1 mb_15">
                                            <input
                                                className="tf-field-input tf-input"
                                                placeholder=""
                                                type="text"
                                                id="txtLoginId"
                                                {...register("username", {
                                                    required: "Login ID is required.",
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9_-]{6,}$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$|^\d{10}$/,
                                                        message: "Please enter a valid Login ID (min 6 characters), Email, or 10-digit Contact number."
                                                    }
                                                })}
                                            />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="txtLoginId">Login ID *</label>
                                            <span className="text-xs text-danger">{errors.username?.message}</span>
                                        </div>
                                        <div className="tf-field style-1 mb_30">
                                            <input
                                                className="tf-field-input tf-input"
                                                placeholder=""
                                                type="password"
                                                id="txtPassword"
                                                {...register("password", { required: "Password is required." })}
                                            />
                                            <label className="tf-field-label fw-4 text_black-2" htmlFor="txtPassword">Password *</label>
                                            <span className="text-xs text-danger">{errors.password?.message}</span>
                                        </div>
                                        <div className="mb_20">
                                            <a href="#recover" className="tf-btn btn-line">Forgot your password?</a>
                                        </div>
                                        <div className="">
                                            <button type="submit" className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center">Log in</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="tf-login-content">
                            <h5 className="mb_36">I'm new here</h5>
                            <p className="mb_20">Sign up for early Sale access plus tailored new arrivals, trends and promotions. To opt out, click unsubscribe in our emails.</p>
                            <Link to="/register" className="tf-btn btn-line">Register<i className="icon icon-arrow1-top-left"></i></Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Login;